import { jsx as _jsx } from "react/jsx-runtime";
import { getFeedbackIcon } from './helpers';
import { IconWrapper } from './styles';
import { Icon, Loading } from '../../../components';
export default function FieldIcon({ feedbackData, disabled, loading, icon, position, hideFeedbackIcon, }) {
    if (loading)
        return (_jsx(IconWrapper, { position: position, cursor: "wait", children: _jsx(Loading, { size: "20", color: "--text-primary" }) }));
    if (feedbackData?.type && !hideFeedbackIcon)
        return (_jsx(IconWrapper, { position: position, children: _jsx(Icon, { name: getFeedbackIcon(feedbackData.type), color: `--semantic-${feedbackData.type}-base`, fill: true }) }));
    if (icon)
        return (_jsx(IconWrapper, { position: position, cursor: icon?.onClick ? 'pointer' : 'default', onClick: () => !disabled && icon.onClick?.(), children: _jsx(Icon, { name: icon.name, color: (disabled ? '--text-disable' : icon.color) || '--text-primary', fill: true }) }));
    return _jsx("div", { style: { display: 'none' } });
}
//# sourceMappingURL=FieldIcon.js.map